import React from "react";
import { ArrowRight, Download } from "lucide-react";
import { BRAND } from "../data/copperx";

const HERO_IMG =
  "https://images.unsplash.com/photo-1647105604066-86ea4247e217?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxjb3BwZXIlMjBwaXBlcyUyMHR1YmVzJTIwaW5kdXN0cmlhbHxlbnwwfHx8fDE3ODA3NTM4NzZ8MA&ixlib=rb-4.1.0&q=85";

export default function Hero({ onQuoteClick }) {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden bg-[#0a0a0b]"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${HERO_IMG}')` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30" />
      <div className="absolute inset-0 grid-pattern opacity-60" />

      {/* Vertical brand strip */}
      <div className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 flex-col items-center gap-6 text-[#94A3B8] text-xs tracking-[0.3em] uppercase rotate-180" style={{ writingMode: "vertical-rl" }}>
        <span>{BRAND.tagline}</span>
        <span className="w-px h-16 bg-[#B85C38]" />
        <span style={{ writingMode: "horizontal-tb", transform: "rotate(180deg)" }}>EST. UAE</span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pb-24 md:pb-32 pt-40 w-full">
        <div className="max-w-4xl">
          <div className="flex items-center gap-3 mb-8 fade-up" style={{ animationDelay: ".05s" }}>
            <span className="section-rule" />
            <span className="text-[#E19672] text-xs tracking-[0.3em] uppercase font-semibold">
              SSR CopperX Trading LLC · Dubai, UAE
            </span>
          </div>

          <h1
            className="text-white text-5xl sm:text-6xl md:text-7xl xl:text-8xl font-semibold leading-[0.95] tracking-tight mb-8 fade-up"
            style={{ animationDelay: ".15s" }}
            data-testid="hero-headline"
          >
            HVAC Copper Tubing,
            <br />
            engineered to the <span className="copper-text">last micron.</span>
          </h1>

          <p
            className="text-[#CBD5E1] text-lg md:text-xl max-w-2xl leading-relaxed mb-10 fade-up"
            style={{ animationDelay: ".3s" }}
            data-testid="hero-subhead"
          >
            The technical authority for HVAC copper tubing &amp; refrigeration piping
            solutions across the GCC. ASTM B280 &amp; B743 compliant. Seamless,
            VRF-ready, R410A certified — supplied at industrial scale.
          </p>

          <div
            className="flex flex-wrap gap-4 mb-16 fade-up"
            style={{ animationDelay: ".45s" }}
          >
            <button
              onClick={onQuoteClick}
              data-testid="hero-cta-quote-button"
              className="group bg-[#B85C38] hover:bg-[#D97757] text-white px-7 py-4 font-medium tracking-wide flex items-center gap-3 transition-colors"
            >
              Request a Quote
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <a
              href="#products"
              data-testid="hero-cta-products-link"
              className="border border-white/40 text-white hover:bg-white hover:text-[#0F172A] px-7 py-4 font-medium tracking-wide flex items-center gap-3 transition-all"
            >
              Explore Catalogue
              <Download size={16} />
            </a>
          </div>

          {/* KPI strip */}
          <div
            className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-6 max-w-3xl border-t border-white/15 pt-8 fade-up"
            style={{ animationDelay: ".6s" }}
            data-testid="hero-kpis"
          >
            {[
              ["6 – 219 mm", "OD Range"],
              [">205 MPa", "Tensile Strength"],
              ["ASTM B280 / B743", "Compliance"],
              ["ME · Africa · Asia", "Distribution"],
            ].map(([v, l]) => (
              <div key={l}>
                <div className="font-mono text-[#E19672] text-base md:text-lg font-medium">{v}</div>
                <div className="text-[#94A3B8] text-xs tracking-[0.18em] uppercase mt-1">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
